import React from "react";
import { Link } from "react-router-dom";
import { FiMessageSquare } from "react-icons/fi";

// Aviso no lugar dos campos de mensagem que foram para a Central de
// Mensagens (Configurações → Mensagens), com link direto para a seção/item.
const MessageCenterLink = ({ section, id, focus, children, onNavigate }) => {
  const params = new URLSearchParams({ tab: "messages" });
  if (section) params.set("section", section);
  if (id != null && id !== "") params.set("id", String(id));
  if (focus) params.set("focus", focus);

  return (
    <div className="flex items-start gap-2 rounded-lg border border-solid border-farmazon-border bg-farmazon-hover px-3 py-2 text-sm text-farmazon-text">
      <FiMessageSquare className="mt-0.5 shrink-0 text-farmazon-text-muted" size={16} />
      <div className="min-w-0">
        <div>{children || "Mensagens automáticas"}</div>
        <Link
          to={`/settings?${params.toString()}`}
          onClick={onNavigate}
          className="text-xs font-semibold text-red-600 no-underline hover:underline"
        >
          Editar em Configurações → Mensagens
        </Link>
      </div>
    </div>
  );
};

export default MessageCenterLink;
